module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (14).45970234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (14).jpg
// module id = 336
// module chunks = 0